// Extracted from death .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const DEATH_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.81569999, 0.81569999, 0.81569999],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.01180000, 0.01180000, 0.01180000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const DEATH_MESH_0: RuneMesh = {
  name: "Death_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.29940000, 0.43310004, 0.67429996,
    0.29940000, 0.43310004, 0.67429996,
    0.39789999, 0.43310001, 0.48409998,
    0.39789999, 0.43310001, 0.48409998,
    0.14309999, 0.43310001, 0.32779998,
    0.14309999, 0.43310001, 0.32779998,
    0.48960000, 0.43309999, 0.11719997,
    0.48960000, 0.43309999, 0.11719997,
    0.39449999, 0.43309999, 0.02889997,
    0.39449999, 0.43309999, 0.02889997,
    -0.00970000, 0.43310001, 0.22589996,
    -0.00970000, 0.43310001, 0.22589996,
    0.20770000, 0.43309999, 0.03909997,
    0.20770000, 0.43309999, 0.03909997,
    0.20770000, 0.43309999, 0.03909997,
    0.20770000, 0.43309999, 0.03909997,
    0.15670000, 0.43309999, -0.16130003,
    0.15670000, 0.43309999, -0.16130003,
    0.35030001, 0.43309996, -0.25640002,
    0.35030001, 0.43309996, -0.25640002,
    0.35370001, 0.43309996, -0.44670004,
    0.35370001, 0.43309996, -0.44670004,
    0.17030001, 0.43309993, -0.62670004,
    0.17030001, 0.43309993, -0.62670004,
    -0.12520000, 0.43309993, -0.68100005,
    -0.12520000, 0.43309993, -0.68100005,
    -0.31209999, 0.43309996, -0.48060003,
    -0.31209999, 0.43309996, -0.48060003,
    -0.30530000, 0.43309996, -0.29040003,
    -0.30530000, 0.43309996, -0.29040003,
    -0.11500000, 0.43309996, -0.20890003,
    -0.11500000, 0.43309996, -0.20890003,
    -0.21349999, 0.43309999, -0.00850003,
    -0.21349999, 0.43309999, -0.00850003,
    -0.40040001, 0.43309999, -0.02890003,
    -0.40040001, 0.43309999, -0.02890003,
    -0.54299998, 0.43309999, 0.06969997,
    -0.54299998, 0.43309999, 0.06969997,
    -0.18640000, 0.43310001, 0.31759998,
    -0.18640000, 0.43310001, 0.31759998,
    -0.44790000, 0.43310001, 0.44329998,
    -0.44790000, 0.43310001, 0.44329998,
    -0.34940001, 0.43310004, 0.63349992,
    -0.34940001, 0.43310004, 0.63349992,
    -0.03350000, 0.43310001, 0.43309996,
    -0.03350000, 0.43310001, 0.43309996,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    -0.11500000, 0.35449997, -0.20890003,
    -0.21349999, 0.35450000, -0.00850003,
    0.20770000, 0.35450000, 0.03909997,
    0.15670000, 0.35450000, -0.16130003,
    0.07180000, 0.35450000, -0.10700003,
    0.07180000, 0.35450000, -0.10700003,
    0.02760000, 0.35449997, -0.30060002,
    -0.07090000, 0.35449997, -0.38550004,
    -0.07770000, 0.35449997, -0.52819997,
    -0.16599999, 0.35449997, -0.53839999,
    -0.15580000, 0.35449997, -0.38890004,
    -0.15580000, 0.35449997, -0.38890004,
    -0.02330000, 0.35450000, -0.15790004,
    -0.30530000, 0.35449997, -0.29040003,
    -0.31209999, 0.35449997, -0.48060003,
    -0.12520000, 0.35449994, -0.68099999,
    0.17030001, 0.35449994, -0.62669998,
    0.35370001, 0.35449997, -0.44670004,
    0.35030001, 0.35449997, -0.25640002,
    0.21110000, 0.35449997, -0.34140003,
    0.21110000, 0.35449997, -0.34140003,
    0.20090000, 0.35449997, -0.48400003,
    0.11260000, 0.35449997, -0.48740003,
    0.11590000, 0.35449997, -0.34480003,
    0.11590000, 0.40139997, -0.34480003,
    0.21110000, 0.40139997, -0.34140003,
    0.11260000, 0.40139997, -0.48740003,
    0.20090000, 0.40139997, -0.48400003,
    -0.02330000, 0.40140000, -0.15790004,
    0.07180000, 0.40140000, -0.10700003,
    0.02760000, 0.40139997, -0.30060002,
    -0.15580000, 0.40139997, -0.38890004,
    -0.15580000, 0.40139997, -0.38890004,
    -0.07090000, 0.40139997, -0.38550004,
    -0.16599999, 0.40139997, -0.53840005,
    -0.07770000, 0.40139997, -0.52820003,
    0.39789999, 0.35450003, 0.48409998,
    0.14309999, 0.35450003, 0.32779998,
    0.48960000, 0.35450000, 0.11719997,
    -0.18640000, 0.35450003, 0.31759998,
    -0.54299998, 0.35450000, 0.06969997,
    -0.40040001, 0.35450000, -0.02890003,
    -0.00970000, 0.35450003, 0.22589996,
    0.39449999, 0.35450000, 0.02889997,
    0.29940000, 0.35450006, 0.67430001,
    -0.03350000, 0.35450003, 0.43309996,
    -0.34940001, 0.35450006, 0.63349998,
    -0.44790000, 0.35450003, 0.44329998,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 77, 78, 1, 77, 1, 0,
    1, 79, 80, 1, 80, 2, 3, 2, 81, 3, 81, 4,
    4, 81, 82, 4, 82, 5, 5, 82, 83, 5, 83, 6,
    6, 83, 84, 6, 84, 7, 7, 84, 85, 7, 85, 8,
    8, 85, 86, 8, 86, 9, 9, 86, 87, 9, 87, 10,
    10, 87, 88, 10, 88, 11, 11, 88, 89, 11, 89, 12,
    12, 89, 90, 12, 90, 13, 13, 90, 91, 13, 91, 14,
    14, 91, 92, 14, 92, 15, 15, 92, 93, 15, 93, 16,
    16, 93, 94, 16, 94, 17, 17, 94, 95, 17, 95, 18,
    18, 95, 96, 18, 96, 19, 19, 96, 97, 19, 97, 20,
    20, 97, 98, 20, 98, 21, 21, 98, 99, 21, 99, 22,
    22, 99, 100, 22, 100, 23, 23, 100, 101, 23, 101, 70,
    70, 101, 102, 70, 102, 71, 71, 102, 103, 71, 103, 72,
    72, 103, 104, 72, 104, 73, 73, 104, 105, 73, 105, 74,
    74, 105, 106, 74, 106, 75, 75, 106, 107, 75, 107, 76,
    76, 107, 78, 76, 78, 77, 78, 108, 79, 78, 79, 1,
    79, 109, 110, 79, 110, 80, 2, 80, 111, 2, 111, 81,
    81, 111, 112, 81, 112, 82, 82, 112, 113, 82, 113, 83,
    83, 113, 114, 83, 114, 84, 84, 114, 115, 84, 115, 85,
    85, 115, 116, 85, 116, 86, 86, 116, 117, 86, 117, 87,
    87, 117, 118, 87, 118, 88, 88, 118, 119, 88, 119, 89,
    89, 119, 120, 89, 120, 90, 90, 120, 121, 90, 121, 91,
    91, 121, 122, 91, 122, 92, 92, 122, 123, 92, 123, 93,
    93, 123, 124, 93, 124, 94, 94, 124, 125, 94, 125, 95,
    95, 125, 126, 95, 126, 96, 96, 126, 127, 96, 127, 97,
    97, 127, 128, 97, 128, 98, 98, 128, 129, 98, 129, 99,
    99, 129, 130, 99, 130, 100, 100, 130, 131, 100, 131, 101,
    101, 131, 132, 101, 132, 102, 102, 132, 133, 102, 133, 103,
    103, 133, 134, 103, 134, 104, 104, 134, 135, 104, 135, 105,
    105, 135, 136, 105, 136, 106, 106, 136, 137, 106, 137, 107,
    107, 137, 108, 107, 108, 78, 108, 138, 109, 108, 109, 79,
    109, 139, 140, 109, 140, 110, 80, 110, 141, 80, 141, 111,
    111, 141, 142, 111, 142, 112, 112, 142, 143, 112, 143, 113,
    113, 143, 144, 113, 144, 114, 114, 144, 145, 114, 145, 115,
    115, 145, 146, 115, 146, 116, 116, 146, 147, 116, 147, 117,
    117, 147, 148, 117, 148, 118, 118, 148, 149, 118, 149, 119,
    119, 149, 150, 119, 150, 120, 120, 150, 151, 120, 151, 121,
    121, 151, 152, 121, 152, 122, 122, 152, 153, 122, 153, 123,
    123, 153, 154, 123, 154, 124, 124, 154, 155, 124, 155, 125,
    125, 155, 156, 125, 156, 126, 126, 156, 157, 126, 157, 127,
    127, 157, 158, 127, 158, 128, 128, 158, 159, 128, 159, 129,
    129, 159, 160, 129, 160, 130, 130, 160, 161, 130, 161, 131,
    131, 161, 162, 131, 162, 132, 132, 162, 163, 132, 163, 133,
    133, 163, 164, 133, 164, 134, 134, 164, 165, 134, 165, 135,
    135, 165, 166, 135, 166, 136, 136, 166, 167, 136, 167, 137,
    137, 167, 138, 137, 138, 108, 138, 168, 139, 138, 139, 109,
    139, 169, 170, 139, 170, 140, 110, 140, 171, 110, 171, 141,
    141, 171, 172, 141, 172, 142, 142, 172, 173, 142, 173, 143,
    143, 173, 174, 143, 174, 144, 144, 174, 175, 144, 175, 145,
    145, 175, 176, 145, 176, 146, 146, 176, 177, 146, 177, 147,
    147, 177, 178, 147, 178, 148, 148, 178, 179, 148, 179, 149,
    149, 179, 180, 149, 180, 150, 150, 180, 181, 150, 181, 151,
    151, 181, 182, 151, 182, 152, 152, 182, 183, 152, 183, 153,
    153, 183, 184, 153, 184, 154, 154, 184, 185, 154, 185, 155,
    155, 185, 186, 155, 186, 156, 156, 186, 187, 156, 187, 157,
    157, 187, 188, 157, 188, 158, 158, 188, 189, 158, 189, 159,
    159, 189, 190, 159, 190, 160, 160, 190, 191, 160, 191, 161,
    161, 191, 192, 161, 192, 162, 162, 192, 193, 162, 193, 163,
    163, 193, 194, 163, 194, 164, 164, 194, 195, 164, 195, 165,
    165, 195, 196, 165, 196, 166, 166, 196, 197, 166, 197, 167,
    167, 197, 168, 167, 168, 138, 168, 198, 169, 168, 169, 139,
    169, 199, 200, 169, 200, 170, 140, 170, 201, 140, 201, 171,
    171, 201, 202, 171, 202, 172, 172, 202, 203, 172, 203, 173,
    173, 203, 204, 173, 204, 174, 174, 204, 205, 174, 205, 175,
    175, 205, 206, 175, 206, 176, 176, 206, 207, 176, 207, 177,
    177, 207, 208, 177, 208, 178, 178, 208, 209, 178, 209, 179,
    179, 209, 210, 179, 210, 180, 180, 210, 211, 180, 211, 181,
    181, 211, 212, 181, 212, 182, 182, 212, 213, 182, 213, 183,
    183, 213, 214, 183, 214, 184, 184, 214, 215, 184, 215, 185,
    185, 215, 216, 185, 216, 186, 186, 216, 217, 186, 217, 187,
    187, 217, 218, 187, 218, 188, 188, 218, 219, 188, 219, 189,
    189, 219, 220, 189, 220, 190, 190, 220, 221, 190, 221, 191,
    191, 221, 222, 191, 222, 192, 192, 222, 223, 192, 223, 193,
    193, 223, 224, 193, 224, 194, 194, 224, 225, 194, 225, 195,
    195, 225, 226, 195, 226, 196, 196, 226, 227, 196, 227, 197,
    197, 227, 198, 197, 198, 168, 198, 228, 199, 198, 199, 169,
    199, 231, 233, 199, 233, 200, 170, 200, 234, 170, 234, 201,
    201, 234, 235, 201, 235, 202, 202, 235, 236, 202, 236, 203,
    203, 236, 237, 203, 237, 204, 204, 237, 238, 204, 238, 205,
    205, 238, 239, 205, 239, 206, 206, 239, 240, 206, 240, 207,
    207, 240, 241, 207, 241, 208, 208, 241, 242, 208, 242, 209,
    209, 242, 243, 209, 243, 210, 210, 243, 244, 210, 244, 211,
    211, 244, 245, 211, 245, 212, 212, 245, 246, 212, 246, 213,
    213, 246, 247, 213, 247, 214, 214, 247, 248, 214, 248, 215,
    215, 248, 249, 215, 249, 216, 216, 249, 250, 216, 250, 217,
    217, 250, 251, 217, 251, 218, 218, 251, 252, 218, 252, 219,
    219, 252, 253, 219, 253, 220, 220, 253, 254, 220, 254, 221,
    221, 254, 255, 221, 255, 222, 222, 255, 256, 222, 256, 223,
    223, 256, 257, 223, 257, 224, 224, 257, 258, 224, 258, 225,
    225, 258, 259, 225, 259, 226, 226, 259, 260, 226, 260, 227,
    227, 260, 228, 227, 228, 198, 228, 262, 231, 228, 231, 199,
    229, 263, 265, 229, 265, 232, 200, 233, 267, 200, 267, 234,
    234, 267, 269, 234, 269, 235, 235, 269, 271, 235, 271, 236,
    236, 271, 273, 236, 273, 237, 237, 273, 275, 237, 275, 238,
    238, 275, 277, 238, 277, 239, 239, 277, 279, 239, 279, 240,
    240, 279, 281, 240, 281, 241, 241, 281, 282, 241, 282, 242,
    242, 282, 284, 242, 284, 243, 243, 284, 286, 243, 286, 244,
    244, 286, 288, 244, 288, 245, 245, 288, 290, 245, 290, 246,
    246, 290, 292, 246, 292, 247, 247, 292, 294, 247, 294, 248,
    248, 294, 296, 248, 296, 249, 249, 296, 298, 249, 298, 250,
    250, 298, 300, 250, 300, 251, 251, 300, 302, 251, 302, 252,
    252, 302, 304, 252, 304, 253, 253, 304, 306, 253, 306, 254,
    254, 306, 308, 254, 308, 255, 255, 308, 310, 255, 310, 256,
    256, 310, 312, 256, 312, 257, 257, 312, 314, 257, 314, 258,
    258, 314, 317, 258, 317, 259, 259, 317, 319, 259, 319, 260,
    260, 319, 262, 260, 262, 228, 261, 320, 264, 261, 264, 230,
    263, 321, 324, 263, 324, 265, 232, 265, 326, 232, 326, 266,
    266, 326, 327, 266, 327, 268, 268, 327, 328, 268, 328, 270,
    270, 328, 329, 270, 329, 272, 272, 329, 330, 272, 330, 274,
    274, 330, 331, 274, 331, 276, 276, 331, 332, 276, 332, 278,
    278, 332, 333, 278, 333, 280, 280, 333, 334, 280, 334, 283,
    283, 334, 335, 283, 335, 285, 285, 335, 336, 285, 336, 287,
    287, 336, 337, 287, 337, 289, 289, 337, 338, 289, 338, 291,
    291, 338, 339, 291, 339, 293, 293, 339, 340, 293, 340, 295,
    295, 340, 341, 295, 341, 297, 297, 341, 342, 297, 342, 299,
    299, 342, 343, 299, 343, 301, 301, 343, 344, 301, 344, 303,
    303, 344, 345, 303, 345, 305, 305, 345, 346, 305, 346, 307,
    307, 346, 347, 307, 347, 309, 309, 347, 348, 309, 348, 311,
    311, 348, 349, 311, 349, 313, 313, 349, 350, 313, 350, 315,
    315, 350, 351, 315, 351, 316, 316, 351, 352, 316, 352, 318,
    318, 352, 320, 318, 320, 261, 320, 353, 323, 320, 323, 264,
    322, 355, 356, 322, 356, 325, 265, 324, 357, 265, 357, 326,
    326, 357, 359, 326, 359, 327, 327, 359, 361, 327, 361, 328,
    328, 361, 363, 328, 363, 329, 329, 363, 365, 329, 365, 330,
    330, 365, 367, 330, 367, 331, 331, 367, 369, 331, 369, 332,
    332, 369, 371, 332, 371, 333, 333, 371, 374, 333, 374, 334,
    334, 374, 376, 334, 376, 335, 335, 376, 378, 335, 378, 336,
    336, 378, 380, 336, 380, 337, 337, 380, 382, 337, 382, 338,
    338, 382, 384, 338, 384, 339, 339, 384, 386, 339, 386, 340,
    340, 386, 388, 340, 388, 341, 341, 388, 390, 341, 390, 342,
    342, 390, 392, 342, 392, 343, 343, 392, 394, 343, 394, 344,
    344, 394, 396, 344, 396, 345, 345, 396, 398, 345, 398, 346,
    346, 398, 400, 346, 400, 347, 347, 400, 402, 347, 402, 348,
    348, 402, 404, 348, 404, 349, 349, 404, 406, 349, 406, 350,
    350, 406, 407, 350, 407, 351, 351, 407, 409, 351, 409, 352,
    352, 409, 353, 352, 353, 320, 354, 411, 355, 354, 355, 322,
    355, 412, 413, 355, 413, 356, 325, 356, 414, 325, 414, 358,
    358, 414, 415, 358, 415, 360, 360, 415, 416, 360, 416, 362,
    362, 416, 417, 362, 417, 364, 364, 417, 418, 364, 418, 366,
    366, 418, 419, 366, 419, 368, 368, 419, 420, 368, 420, 370,
    370, 420, 421, 370, 421, 372, 372, 421, 422, 372, 422, 373,
    373, 422, 423, 373, 423, 375, 375, 423, 424, 375, 424, 377,
    377, 424, 425, 377, 425, 379, 379, 425, 426, 379, 426, 381,
    381, 426, 427, 381, 427, 383, 383, 427, 428, 383, 428, 385,
    385, 428, 429, 385, 429, 387, 387, 429, 430, 387, 430, 389,
    389, 430, 431, 389, 431, 391, 391, 431, 432, 391, 432, 393,
    393, 432, 433, 393, 433, 395, 395, 433, 434, 395, 434, 397,
    397, 434, 435, 397, 435, 399, 399, 435, 436, 399, 436, 401,
    401, 436, 437, 401, 437, 403, 403, 437, 438, 403, 438, 405,
    405, 438, 439, 405, 439, 408, 408, 439, 440, 408, 440, 410,
    410, 440, 411, 410, 411, 354, 411, 441, 412, 411, 412, 355,
    412, 442, 443, 412, 443, 413, 356, 413, 444, 356, 444, 414,
    414, 444, 445, 414, 445, 415, 415, 445, 446, 415, 446, 416,
    416, 446, 447, 416, 447, 417, 417, 447, 448, 417, 448, 418,
    418, 448, 449, 418, 449, 419, 419, 449, 450, 419, 450, 420,
    420, 450, 451, 420, 451, 421, 421, 451, 452, 421, 452, 422,
    422, 452, 453, 422, 453, 423, 423, 453, 454, 423, 454, 424,
    424, 454, 455, 424, 455, 425, 425, 455, 456, 425, 456, 426,
    426, 456, 457, 426, 457, 427, 427, 457, 458, 427, 458, 428,
    428, 458, 459, 428, 459, 429, 429, 459, 460, 429, 460, 430,
    430, 460, 461, 430, 461, 431, 431, 461, 462, 431, 462, 432,
    432, 462, 463, 432, 463, 433, 433, 463, 464, 433, 464, 434,
    434, 464, 465, 434, 465, 435, 435, 465, 466, 435, 466, 436,
    436, 466, 467, 436, 467, 437, 437, 467, 468, 437, 468, 438,
    438, 468, 469, 438, 469, 439, 439, 469, 470, 439, 470, 440,
    440, 470, 441, 440, 441, 411, 441, 471, 442, 441, 442, 412,
    442, 472, 473, 442, 473, 443, 413, 443, 474, 413, 474, 444,
    444, 474, 475, 444, 475, 445, 445, 475, 476, 445, 476, 446,
    446, 476, 477, 446, 477, 447, 447, 477, 478, 447, 478, 448,
    448, 478, 479, 448, 479, 449, 449, 479, 480, 449, 480, 450,
    450, 480, 481, 450, 481, 451, 451, 481, 482, 451, 482, 452,
    452, 482, 483, 452, 483, 453, 453, 483, 484, 453, 484, 454,
    454, 484, 485, 454, 485, 455, 455, 485, 486, 455, 486, 456,
    456, 486, 487, 456, 487, 457, 457, 487, 488, 457, 488, 458,
    458, 488, 489, 458, 489, 459, 459, 489, 490, 459, 490, 460,
    460, 490, 491, 460, 491, 461, 461, 491, 492, 461, 492, 462,
    462, 492, 493, 462, 493, 463, 463, 493, 494, 463, 494, 464,
    464, 494, 495, 464, 495, 465, 465, 495, 496, 465, 496, 466,
    466, 496, 497, 466, 497, 467, 467, 497, 498, 467, 498, 468,
    468, 498, 499, 468, 499, 469, 469, 499, 500, 469, 500, 470,
    470, 500, 471, 470, 471, 441, 471, 501, 472, 471, 472, 442,
    472, 502, 503, 472, 503, 473, 443, 473, 504, 443, 504, 474,
    474, 504, 505, 474, 505, 475, 475, 505, 506, 475, 506, 476,
    476, 506, 507, 476, 507, 477, 477, 507, 508, 477, 508, 478,
    478, 508, 509, 478, 509, 479, 479, 509, 510, 479, 510, 480,
    480, 510, 511, 480, 511, 481, 481, 511, 512, 481, 512, 482,
    482, 512, 513, 482, 513, 483, 483, 513, 514, 483, 514, 484,
    484, 514, 515, 484, 515, 485, 485, 515, 516, 485, 516, 486,
    486, 516, 517, 486, 517, 487, 487, 517, 518, 487, 518, 488,
    488, 518, 519, 488, 519, 489, 489, 519, 520, 489, 520, 490,
    490, 520, 521, 490, 521, 491, 491, 521, 522, 491, 522, 492,
    492, 522, 523, 492, 523, 493, 493, 523, 524, 493, 524, 494,
    494, 524, 525, 494, 525, 495, 495, 525, 526, 495, 526, 496,
    496, 526, 527, 496, 527, 497, 497, 527, 528, 497, 528, 498,
    498, 528, 529, 498, 529, 499, 499, 529, 530, 499, 530, 500,
    500, 530, 501, 500, 501, 471, 501, 531, 502, 501, 502, 472,
    502, 532, 533, 502, 533, 503, 473, 503, 534, 473, 534, 504,
    504, 534, 535, 504, 535, 505, 505, 535, 536, 505, 536, 506,
    506, 536, 537, 506, 537, 507, 507, 537, 538, 507, 538, 508,
    508, 538, 539, 508, 539, 509, 509, 539, 540, 509, 540, 510,
    510, 540, 541, 510, 541, 511, 511, 541, 542, 511, 542, 512,
    512, 542, 543, 512, 543, 513, 513, 543, 544, 513, 544, 514,
    514, 544, 545, 514, 545, 515, 515, 545, 546, 515, 546, 516,
    516, 546, 547, 516, 547, 517, 517, 547, 548, 517, 548, 518,
    518, 548, 549, 518, 549, 519, 519, 549, 550, 519, 550, 520,
    520, 550, 551, 520, 551, 521, 521, 551, 552, 521, 552, 522,
    522, 552, 553, 522, 553, 523, 523, 553, 554, 523, 554, 524,
    524, 554, 555, 524, 555, 525, 525, 555, 556, 525, 556, 526,
    526, 556, 557, 526, 557, 527, 527, 557, 558, 527, 558, 528,
    528, 558, 559, 528, 559, 529, 529, 559, 560, 529, 560, 530,
    530, 560, 531, 530, 531, 501, 531, 561, 532, 531, 532, 502,
    532, 562, 563, 532, 563, 533, 503, 533, 564, 503, 564, 534,
    534, 564, 565, 534, 565, 535, 535, 565, 566, 535, 566, 536,
    536, 566, 567, 536, 567, 537, 537, 567, 568, 537, 568, 538,
    538, 568, 569, 538, 569, 539, 539, 569, 570, 539, 570, 540,
    540, 570, 571, 540, 571, 541, 541, 571, 572, 541, 572, 542,
    542, 572, 573, 542, 573, 543, 543, 573, 574, 543, 574, 544,
    544, 574, 575, 544, 575, 545, 545, 575, 576, 545, 576, 546,
    546, 576, 577, 546, 577, 547, 547, 577, 578, 547, 578, 548,
    548, 578, 579, 548, 579, 549, 549, 579, 580, 549, 580, 550,
    550, 580, 581, 550, 581, 551, 551, 581, 582, 551, 582, 552,
    552, 582, 583, 552, 583, 553, 553, 583, 584, 553, 584, 554,
    554, 584, 585, 554, 585, 555, 555, 585, 586, 555, 586, 556,
    556, 586, 587, 556, 587, 557, 557, 587, 588, 557, 588, 558,
    558, 588, 589, 558, 589, 559, 559, 589, 590, 559, 590, 560,
    560, 590, 561, 560, 561, 531, 561, 591, 562, 561, 562, 532,
    562, 592, 563, 533, 563, 593, 533, 593, 564, 564, 593, 594,
    564, 594, 565, 565, 594, 595, 565, 595, 566, 566, 595, 596,
    566, 596, 567, 567, 596, 597, 567, 597, 568, 568, 597, 598,
    568, 598, 569, 569, 598, 599, 569, 599, 570, 570, 599, 600,
    570, 600, 571, 571, 600, 601, 571, 601, 572, 572, 601, 602,
    572, 602, 573, 573, 602, 603, 573, 603, 574, 574, 603, 604,
    574, 604, 575, 575, 604, 605, 575, 605, 576, 576, 605, 606,
    576, 606, 577, 577, 606, 607, 577, 607, 578, 578, 607, 608,
    578, 608, 579, 579, 608, 609, 579, 609, 580, 580, 609, 610,
    580, 610, 581, 581, 610, 611, 581, 611, 582, 582, 611, 612,
    582, 612, 583, 583, 612, 613, 583, 613, 584, 584, 613, 614,
    584, 614, 585, 585, 614, 615, 585, 615, 586, 586, 615, 616,
    586, 616, 587, 587, 616, 617, 587, 617, 588, 588, 617, 618,
    588, 618, 589, 589, 618, 619, 589, 619, 590, 590, 619, 591,
    590, 591, 561, 591, 592, 562, 563, 592, 593, 593, 592, 594,
    594, 592, 595, 595, 592, 596, 596, 592, 597, 597, 592, 598,
    598, 592, 599, 599, 592, 600, 600, 592, 601, 601, 592, 602,
    602, 592, 603, 603, 592, 604, 604, 592, 605, 605, 592, 606,
    606, 592, 607, 607, 592, 608, 608, 592, 609, 609, 592, 610,
    610, 592, 611, 611, 592, 612, 612, 592, 613, 613, 592, 614,
    614, 592, 615, 615, 592, 616, 616, 592, 617, 617, 592, 618,
    618, 592, 619, 619, 592, 591, 56, 54, 620, 56, 620, 621,
    39, 56, 621, 39, 621, 622, 70, 71, 72, 72, 73, 74,
    74, 75, 76, 76, 77, 0, 0, 3, 4, 4, 5, 6,
    6, 7, 8, 8, 9, 10, 10, 11, 12, 12, 13, 14,
    14, 15, 16, 16, 43, 45, 16, 45, 47, 12, 14, 16,
    8, 10, 12, 4, 6, 8, 76, 0, 4, 72, 74, 76,
    23, 70, 72, 69, 25, 23, 67, 69, 23, 76, 4, 8,
    12, 16, 47, 12, 47, 49, 67, 23, 72, 61, 63, 65,
    67, 72, 76, 65, 67, 76, 8, 12, 49, 8, 49, 51,
    61, 65, 76, 37, 35, 59, 61, 76, 8, 57, 37, 59,
    61, 8, 51, 53, 55, 57, 61, 51, 53, 53, 57, 59,
    53, 59, 61, 54, 52, 633, 54, 633, 620, 40, 38, 622,
    40, 622, 623, 42, 40, 623, 42, 623, 638, 644, 645, 640,
    644, 640, 643, 646, 644, 643, 646, 643, 642, 647, 646, 642,
    647, 642, 641, 645, 647, 641, 645, 641, 639, 44, 42, 638,
    44, 638, 637, 46, 44, 637, 46, 637, 636, 48, 46, 636,
    48, 636, 635, 50, 48, 635, 50, 635, 634, 52, 50, 634,
    52, 634, 633, 648, 649, 624, 648, 624, 632, 650, 648, 632,
    650, 632, 626, 651, 653, 627, 651, 627, 630, 654, 652, 631,
    654, 631, 629, 655, 654, 629, 655, 629, 628, 653, 655, 628,
    653, 628, 627, 649, 650, 626, 649, 626, 625, 28, 26, 656,
    28, 656, 657, 30, 28, 657, 30, 657, 658, 26, 24, 664,
    26, 664, 656, 32, 30, 658, 32, 658, 663, 62, 60, 660,
    62, 660, 659, 64, 62, 659, 64, 659, 667, 66, 64, 667,
    66, 667, 666, 68, 66, 666, 68, 666, 665, 24, 68, 665,
    24, 665, 664, 34, 32, 663, 34, 663, 662, 58, 34, 662,
    58, 662, 661, 60, 58, 661, 60, 661, 660, 27, 29, 31,
    33, 35, 36, 33, 36, 41, 41, 43, 16, 16, 17, 18,
    18, 19, 20, 20, 21, 22, 22, 23, 25, 22, 25, 27,
    18, 20, 22, 41, 16, 18, 33, 41, 18, 18, 22, 27,
    31, 33, 18, 27, 31, 18,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.02589975, 0.99649042, 0.07959923,
    -0.07379823, -0.94747720, -0.31119251,
    -0.07379823, -0.94747720, -0.31119251,
    -0.78389212, -0.58129413, 0.21819780,
    -0.78389212, -0.58129413, 0.21819780,
    -0.83090886, 0.55640594, -0.00170002,
    -0.83090901, 0.55640602, -0.00160002,
    -0.82141706, -0.56421170, -0.08330173,
    -0.82141706, -0.56421170, -0.08330173,
    -0.11759437, -0.59927131, 0.79186202,
    -0.11759437, -0.59927131, 0.79186202,
    -0.06109701, 0.18439101, 0.98095214,
    -0.06110301, 0.18440910, 0.98094837,
    -0.30319536, -0.91548592, -0.26449594,
    -0.30320338, -0.91551013, -0.26440293,
    -0.30328613, -0.91545817, -0.26448791,
    -0.30331388, -0.91544199, -0.26451212,
    -0.73360249, 0.58910200, -0.33880116,
    -0.73360249, 0.58910200, -0.33880116,
    -0.67108847, -0.60648956, -0.42639264,
    -0.67108847, -0.60648956, -0.42639264,
    -0.72018355, -0.62808562, 0.29469326,
    -0.72018355, -0.62808562, 0.29469326,
    -0.35150692, -0.64681268, 0.67681330,
    -0.35150692, -0.64681268, 0.67681330,
    0.24790727, -0.61331803, 0.74992198,
    0.24790727, -0.61331803, 0.74992198,
    0.72738931, -0.63019077, 0.27159600,
    0.72738931, -0.63019077, 0.27159600,
    0.65731277, -0.60421177, -0.45040876,
    0.65731277, -0.60421177, -0.45040876,
    0.76750293, 0.57470222, -0.28400109,
    0.76750293, 0.57470222, -0.28400109,
    0.72596615, -0.56137382, -0.39728149,
    0.72591886, -0.56141458, -0.39731030,
    0.01059983, -0.60059011, 0.79948681,
    0.01059983, -0.60059011, 0.79948681,
    0.82796592, -0.56077691, 0.00129995,
    0.82793447, -0.56082334, 0.00130005,
    0.82920277, 0.55500185, 0.06630022,
    0.82920277, 0.55500185, 0.06630022,
    0.77540953, -0.57580706, 0.25920318,
    0.77536487, -0.57587391, 0.25918826,
    0.21360053, -0.57290142, -0.79130195,
    0.21360053, -0.57290142, -0.79130195,
    0.02469988, 0.59989693, -0.79969594,
    0.02469988, 0.59989693, -0.79969594,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    0.76750293, -0.57470222, -0.28400109,
    0.72596615, 0.56137382, -0.39728149,
    -0.65749367, 0.48879529, -0.57339449,
    -0.73360249, -0.58910200, -0.33880116,
    0.14640197, 0.97041304, 0.19200260,
    0.14639917, 0.97039440, 0.19209889,
    0.01029973, -0.98497397, -0.17239544,
    0.29409399, 0.91008143, 0.29199403,
    0.59169686, -0.58649683, -0.55309701,
    -0.56807747, -0.56837752, -0.59517642,
    -0.56622991, -0.58323076, 0.58243075,
    -0.56629780, -0.58319775, 0.58239779,
    -0.75631979, -0.58561537, 0.29160764,
    0.65731277, 0.60421177, -0.45040876,
    0.72738931, 0.63019077, 0.27159600,
    0.24790727, 0.61331803, 0.74992198,
    -0.35150692, 0.64681268, 0.67681330,
    -0.72018355, 0.62808562, 0.29469326,
    -0.66662353, 0.61332166, -0.42361494,
    0.31100556, 0.90181612, 0.30000537,
    0.31090589, 0.90181711, 0.30010568,
    0.56471488, -0.58341536, -0.58371535,
    -0.57470196, -0.57410198, -0.58320200,
    -0.57920527, -0.58060527, 0.57220519,
    -0.57920527, 0.58060527, 0.57220519,
    0.59021059, 0.57201025, 0.56961015,
    -0.57470196, 0.57410198, -0.58320200,
    0.56471488, 0.58341536, -0.58371535,
    -0.75631979, 0.58561537, 0.29160764,
    0.50698571, 0.54878448, 0.66468118,
    0.04989859, 0.54218475, -0.83877638,
    -0.56622991, 0.58323076, 0.58243075,
    -0.56629780, 0.58319775, 0.58239779,
    0.58170581, 0.57290572, 0.57740575,
    -0.56807747, 0.56837752, -0.59517642,
    0.59169686, 0.58649683, -0.55309701,
    -0.78389212, 0.58129413, 0.21819780,
    -0.83090886, -0.55640594, -0.00170002,
    -0.82141706, 0.56421170, -0.08330173,
    0.82920277, -0.55500185, 0.06630022,
    0.82796592, 0.56077691, 0.00129995,
    0.01059983, 0.60059011, 0.79948681,
    -0.04920089, -0.61111105, 0.79001428,
    -0.11759437, 0.59927131, 0.79186202,
    -0.18959542, 0.56998623, -0.79948063,
    0.02469988, -0.59989693, -0.79969594,
    0.21360053, 0.57290142, -0.79130195,
    0.77540953, 0.57580706, 0.25920318,
  ]),
  materialIndex: 0,
};

const DEATH_MESH_1: RuneMesh = {
  name: "Death_Rune_primitive1",
  positions: new Float32Array([
    -0.11500000, 0.35449997, -0.20890003,
    -0.21349999, 0.35450000, -0.00850003,
    0.20770000, 0.35450000, 0.03909997,
    0.15670000, 0.35450000, -0.16130003,
    0.07180000, 0.35450000, -0.10700003,
    0.02760000, 0.35449997, -0.30060002,
    -0.07090000, 0.35449997, -0.38550004,
    -0.07770000, 0.35449997, -0.52819997,
    -0.16599999, 0.35449997, -0.53839999,
    -0.15580000, 0.35449997, -0.38890004,
    -0.02330000, 0.35450000, -0.15790004,
    -0.30530000, 0.35449997, -0.29040003,
    -0.31209999, 0.35449997, -0.48060003,
    -0.12520000, 0.35449994, -0.68099999,
    0.17030001, 0.35449994, -0.62669998,
    0.35370001, 0.35449997, -0.44670004,
    0.35030001, 0.35449997, -0.25640002,
    0.21110000, 0.35449997, -0.34140003,
    0.20090000, 0.35449997, -0.48400003,
    0.11260000, 0.35449997, -0.48740003,
    0.11590000, 0.35449997, -0.34480003,
    0.39789999, 0.35450003, 0.48409998,
    0.14309999, 0.35450003, 0.32779998,
    0.48960000, 0.35450000, 0.11719997,
    -0.18640000, 0.35450003, 0.31759998,
    -0.54299998, 0.35450000, 0.06969997,
    -0.40040001, 0.35450000, -0.02890003,
    -0.00970000, 0.35450003, 0.22589996,
    0.39449999, 0.35450000, 0.02889997,
    0.29940000, 0.35450006, 0.67430001,
    -0.03350000, 0.35450003, 0.43309996,
    -0.34940001, 0.35450006, 0.63349998,
    -0.44790000, 0.35450003, 0.44329998,
  ]),
  indices: new Uint16Array([
    24, 25, 26, 27, 28, 23, 24, 26, 27, 31, 32, 24,
    21, 29, 30, 30, 31, 24, 24, 27, 23, 22, 21, 30,
    24, 23, 22, 24, 22, 30, 3, 2, 4, 5, 6, 19,
    3, 4, 5, 17, 16, 3, 5, 19, 20, 20, 17, 3,
    3, 5, 20, 10, 4, 2, 2, 1, 0, 0, 11, 12,
    13, 14, 7, 13, 7, 8, 10, 2, 0, 6, 5, 10,
    9, 6, 10, 10, 0, 12, 12, 13, 8, 9, 10, 12,
    12, 8, 9, 19, 6, 7, 14, 15, 16, 16, 17, 18,
    18, 19, 7, 14, 16, 18, 7, 14, 18,
  ]),
  normals: new Float32Array([
    0.76750293, -0.57470222, -0.28400109,
    0.72596615, 0.56137382, -0.39728149,
    -0.65749367, 0.48879529, -0.57339449,
    -0.73357764, -0.58908203, -0.33888967,
    0.14640197, 0.97041304, 0.19200260,
    0.01029955, -0.98495699, -0.17249247,
    0.29409399, 0.91008143, 0.29199403,
    0.59169686, -0.58649683, -0.55309701,
    -0.56811129, -0.56841134, -0.59511184,
    -0.56629780, -0.58319775, 0.58239779,
    -0.75631979, -0.58561537, 0.29160764,
    0.65731277, 0.60421177, -0.45040876,
    0.72738931, 0.63019077, 0.27159600,
    0.24790727, 0.61331803, 0.74992198,
    -0.35150692, 0.64681268, 0.67681330,
    -0.72018355, 0.62808562, 0.29469326,
    -0.66662353, 0.61332166, -0.42361494,
    0.31099621, 0.90178907, 0.30009637,
    0.56471488, -0.58341536, -0.58371535,
    -0.57470196, -0.57410198, -0.58320200,
    -0.57920527, -0.58060527, 0.57220519,
    -0.78389212, 0.58129413, 0.21819780,
    -0.83090901, -0.55640602, -0.00160002,
    -0.82141706, 0.56421170, -0.08330173,
    0.82920277, -0.55500185, 0.06630022,
    0.82796592, 0.56077691, 0.00129995,
    0.01059983, 0.60059011, 0.79948681,
    -0.04919788, -0.61117367, 0.78996602,
    -0.11760367, 0.59931873, 0.79182475,
    -0.18959542, 0.56998623, -0.79948063,
    0.02469988, -0.59989693, -0.79969594,
    0.21360053, 0.57290142, -0.79130195,
    0.77540953, 0.57580706, 0.25920318,
  ]),
  materialIndex: 1,
};

const DEATH_MESH_2: RuneMesh = {
  name: "Death_Rune_primitive2",
  positions: new Float32Array([
    0.11590000, 0.40139997, -0.34480003,
    0.21110000, 0.40139997, -0.34140003,
    0.11260000, 0.40139997, -0.48740003,
    0.20090000, 0.40139997, -0.48400003,
    -0.02330000, 0.40140000, -0.15790004,
    0.07180000, 0.40140000, -0.10700003,
    0.02760000, 0.40139997, -0.30060002,
    -0.15580000, 0.40139997, -0.38890004,
    -0.07090000, 0.40139997, -0.38550004,
    -0.16599999, 0.40139997, -0.53840005,
    -0.07770000, 0.40139997, -0.52820003,
  ]),
  indices: new Uint16Array([
    4, 6, 5, 10, 8, 7, 10, 7, 9, 3, 1, 0,
    3, 0, 2,
  ]),
  normals: new Float32Array([
    -0.57920527, 0.58060527, 0.57220519,
    0.59021059, 0.57201025, 0.56961015,
    -0.57470196, 0.57410198, -0.58320200,
    0.56471488, 0.58341536, -0.58371535,
    -0.75631979, 0.58561537, 0.29160764,
    0.50698571, 0.54878448, 0.66468118,
    0.04979885, 0.54218746, -0.83878056,
    -0.56629780, 0.58319775, 0.58239779,
    0.58170581, 0.57290572, 0.57740575,
    -0.56811129, 0.56841134, -0.59511184,
    0.59169686, 0.58649683, -0.55309701,
  ]),
  materialIndex: 2,
};

export const DEATH_MESHES: RuneMesh[] = [
  DEATH_MESH_0,
  DEATH_MESH_1,
  DEATH_MESH_2,
];
